/**
 * Important Notice:
 *
 * If Scripts like select2, owlCarousel or fancybox are needed,
 * the have to be moved from libs_notUsed to libs. Actually only
 * the flexnav files are in the folder libs.
 */

jQuery(function($) {

    /* form label animation */

    $(".fieldWrapper input[type='text'], .fieldWrapper input[type='email'], .fieldWrapper textarea").on('blur', function () {
        if (!$(this).val()) {
            $(this).parent().parent().removeClass('active');
        }
    }).on('focus', function () {
        $(this).parent().parent().addClass('active');
    });

    /* file form fields */

    $('input[type=file]').on('change', function () {
        var filename = $(this).val().split('\\').pop();
        if (filename)
            $(this).parent().parent().find('label').html(filename).addClass('selected');
        else
            $(this).parent().parent().find('label').html('').removeClass('selected');
    });

});
